module.exports = __webpack_public_path__ + "static/media/about_armenia_3.2a0c3825.jpg";